import { FC } from "react";

interface IconDownloadProps {
  className?: string;
}

const IconDownload: FC<IconDownloadProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C12.4142 2 12.75 2.33579 12.75 2.75V13.1893L15.4697 10.4697C15.7626 10.1768 16.2374 10.1768 16.5303 10.4697C16.8232 10.7626 16.8232 11.2374 16.5303 11.5303L12.5303 15.5303C12.2374 15.8232 11.7626 15.8232 11.4697 15.5303L7.46967 11.5303C7.17678 11.2374 7.17678 10.7626 7.46967 10.4697C7.76256 10.1768 8.23744 10.1768 8.53033 10.4697L11.25 13.1893V2.75C11.25 2.33579 11.5858 2 12 2Z"
        fill="#1C274C"
      />
      <path
        opacity="0.5"
        d="M4 20C4 19.5858 4.33579 19.25 4.75 19.25H19.25C19.6642 19.25 20 19.5858 20 20C20 20.4142 19.6642 20.75 19.25 20.75H4.75C4.33579 20.75 4 20.4142 4 20Z"
        fill="#1C274C"
      />
    </svg>
  );
};

export default IconDownload;
